import { GlobalState } from '../../reducers';

export const getBasicToken = (state: GlobalState) => state?.auth?.token;
